import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { IFAlerta } from '../types/financiamento.types';
import { fetchAlertasAtivos, fetchAlertasCount, marcarAlertaLido } from '../services/ifDataService';

export type { IFAlerta };

export function useIFAlertas(contratoId?: string) {
  return useQuery({
    queryKey: ['if-alertas', contratoId],
    queryFn: async () => {
      return (await fetchAlertasAtivos(contratoId)) as IFAlerta[];
    },
  });
}

export function useIFAlertasCount() {
  return useQuery({
    queryKey: ['if-alertas-count'],
    queryFn: fetchAlertasCount,
  });
}

export function useIFMarcarAlertaLido() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: marcarAlertaLido,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['if-alertas'] });
      qc.invalidateQueries({ queryKey: ['if-alertas-count'] });
    },
  });
}
